<div class="dynamic-system view-box-container" *ngIf="dataIsLoaded">
    <form [formGroup]="myFormGroup" (ngSubmit)="onSubmit()">
        <div class="graph-property-container"
            *ngIf="myFormTemplate.sectionTitle == 'property' && (financialSummary || financialSummary=='Yes')">
            <div class="graph-property-equity-gain">
                <app-property-equity-gain [equity]="propertyEquity" [equityGain]="propertyEquityGain"
                    [debt]="propertyDebt"></app-property-equity-gain>
            </div>
            <div class="graph-property-rental-income-expense">
                <app-property-rental-income-expense [income]="propertyIncomePerYear"
                    [serviceCharge]="propertyAnnualServiceCharge"
                    [repairsAndMaintenance]="propertyAnnualRepairsAndMaintenance"
                    [legalAndOtherProffessionalServices]="propertyAnnualLegalAndOtherProffessionalServices"
                    [managingAgentCharge]="propertyYearlyManagingAgentCharge" [utilitiesCharge]="propertyUtilities"
                    [insurance]="propertyInsurances" [primaryMortgageRepayments]="propertyPrimaryMortgageRepayments"
                    [nonPrimaryMortgageRepayments]="propertyNonPrimaryMortgageRepayments">
                </app-property-rental-income-expense>
            </div>
        </div>
        <section class="dynamic-system-header"
            [ngStyle]="{'column-count': (myFormTemplate.sectionTitle === 'general expenses')?1:1}">
            <ng-container *ngFor="let form_elem of myFormTemplate.fields">
                <div [ngSwitch]="form_elem.inputtype"
                    [ngClass]="{'view-box-dynamic-flex':myFormTemplate.sectionTitle != 'general expenses',
                                'view-box-dynamic-flex-one-column':myFormTemplate.sectionTitle === 'general expenses',
                                'dynamicFlexJointOwnersList':isCommon
                                }">

                    <section *ngSwitchCase="'jointOwnersList'">
                        <div class="form-group">
                            <div>
                                <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                            </div>
                            <div class="notes-memo joint-owners-list">
                                <div class="owner-info-title row">
                                    <div class="owner-name-title col-sm-4">Owner</div>
                                    <div class="owner-is-common-title col-sm-4">Type</div>
                                    <div class="owner-share-title col-sm-4" *ngIf="isCommon">Share</div>
                                </div>
                                <div class="owner-info row" *ngFor="let owner of jointOwnersList">
                                    <div class="owner-name col-sm-4">{{owner.owner.first + " " + owner.owner.last}}
                                    </div>
                                    <div class="is-common col-sm-4" *ngIf="isCommon">Tenants in common</div>
                                    <div class="is-common col-sm-4" *ngIf="!isCommon && jointOwnersList.length>=2">Joint
                                        Tenant</div>
                                    <div class="is-common col-sm-4" *ngIf="!isCommon && jointOwnersList.length<2">Owner
                                    </div>
                                    <div class="owner-share col-sm-4" *ngIf="owner.share && owner.share != 100">{{owner.share}}%</div>
                                </div>
                                <!-- {{myFormGroup.get(form_elem.fieldid).value | json}} -->
                            </div>
                        </div>
                    </section>
                    <div *ngSwitchCase="'freetext'" class="freetext">
                        <div class="form-group" *ngIf="form_elem.geFrenquency != true">
                            <div>
                                <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                            </div>
                            <div class="check-fa-group">
                                <input class="view-field" type="text" formControlName="{{form_elem.fieldid}}"
                                    required="{{form_elem.mandatory}}" readonly />
                            </div>
                            <!-- <div *ngIf="form_elem.fieldid == 'propertyHasInsurances'">
                                {{myFormGroup.get(form_elem.fieldid).value}}
                            </div> -->
                        </div>
                    </div>

                    <div *ngSwitchCase="'dropdownid'" class="dropdownid">
                        <div class="form-group">
                            <div>
                                <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                            </div>
                            <div class="check-fa-group">pro
                                <select class="form-control" formControlName="{{form_elem.fieldid}}"
                                    [ngClass]="{'is-invalid' :submitted && myFormGroup.get(form_elem.fieldid).errors}">
                                    <option *ngFor="let opt of form_elem.itemArray" value="{{opt.Id}}">
                                        {{opt.itemName}}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>
                    <div class="information-label" *ngIf="false">
                        <div class="form-group">
                            <label class="col-sm-12">{{form_elem.explanation}}</label>
                        </div>
                    </div>
                    <div *ngSwitchCase="'memofree'" class="memo">
                        <div class="form-group" *ngIf="myFormGroup.get(form_elem.fieldid).value">
                            <div>
                                <label>{{form_elem.label}}</label>
                            </div>
                            <div class="check-fa-group">
                                {{myFormGroup.get(form_elem.fieldid).value}}
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'memo'" class="memo">
                        <div class="form-group">
                            <div>
                                <label>{{form_elem.label}}</label>
                            </div>
                            <div class="check-fa-group notes-memo">
                                {{myFormGroup.get(form_elem.fieldid).value}}
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'number'" class="number">
                        <div class="form-group">
                            <div>
                                <label for="{{form_elem.fieldid}}">{{form_elem.label}}
                                    <span *ngIf="totalSharesValue>0 && form_elem.fieldid=='shareCount'">
                                        <!-- ({{totalSharesValue}}) -->
                                    </span>
                                    <ng-container
                                        *ngIf="showFrequencies && myFormGroup.value[form_elem.fieldid+'Freq']">
                                        {{myFormGroup.value[form_elem.fieldid+'Freq']}}
                                    </ng-container>
                                    <span *ngIf="form_elem.currency">({{form_elem.currency}})</span>
                                    <!-- <span *ngIf="form_elem.geFrenquency == true">(&#163;)</span> -->
                                    <span *ngIf="form_elem.percent">({{form_elem.percent}})</span>
                                </label>
                            </div>
                            <div>
                                <div class="check-fa-group">
                                    {{adjustToDefaultCurrency(myFormGroup.get(form_elem.fieldid).value) | number : '1.2-2'}}
                                </div>
                                <span
                                    *ngIf="form_elem.percent && form_elem.fieldid != 'sharePercentage'">{{form_elem.percent}}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'datepicker'" class="datepicker">
                        <div class="form-group">
                            <div>
                                <label>{{form_elem.label}}
                                    <span class="required-field">{{form_elem.required}}</span>
                                </label>
                            </div>
                            <div class="check-fa-group">
                                <input type="date" readonly formControlName="{{form_elem.fieldid}}" min="1890-01-01"
                                    max="2050-12-31">
                            </div>
                        </div>
                        <div *ngIf="submitted && myFormGroup.get(form_elem.fieldid).errors" class="invalid-feedback">
                            <div *ngIf="form_elem.mandatory">This is a required field.</div>
                        </div>
                    </div>
                    <div *ngSwitchCase="'multicheckbox'" class="conditionaldropdown-dynamic">
                        <div *ngIf="dummyShowTrigger?showMe(form_elem.fieldid):showMe(form_elem.fieldid)">
                            <div class="form-group">
                                <label for="{{form_elem.fieldid}}">{{form_elem.label}}</label>
                                <div class="check-fa-group">
                                    <app-multi-checkbox [parentForm]="myFormGroup" [fieldId]="form_elem.fieldid"
                                        [listSource]="form_elem.listSource" [label]="form_elem.label" [view]="true">
                                    </app-multi-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
            <div class="last-update">
                Last updated by {{lastUpdateByName}} on {{myItem.lastUpdate | date: 'dd/MM/yyyy'}}
            </div>
        </section>
    </form>
</div>